import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface IStatus {
  id: number
  name: string
  options: any
}

function StatusAutocomplete({ value, handleInputChange, options }: any) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleAutoCompleteChange = (status: IStatus | null) => {
    handleInputChange('status', status)
  }

  return (
    <Autocomplete
      id="autocomplete-status"
      disableClearable
      value={value}
      onChange={(_, value) => handleAutoCompleteChange(value)}
      options={options}
      getOptionLabel={(option: any) => option.name}
      renderInput={params => (
        <TextField
          {...params}
          label={t('status')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.status}
          helperText={msgForm.status}
        />
      )}
    />
  )
}

export default StatusAutocomplete
